import { get } from "lodash";

export const shouldShowOriginationFeeAmount = loan => Boolean(get(loan, "closingCosts.originationFeeAmount"));

export const shouldShowModificationFee = loan => Boolean(get(loan, "closingCosts.modificationFeeAmount"));

export const shouldShowBrokerFeeAmount = loan => Boolean(get(loan, "closingCosts.brokerFeeAmount"));

export const shouldShowLenderLegalFeeAmount = loan => Boolean(get(loan, "closingCosts.lenderLegalFeeAmount"));

export const shouldShowBorrowerLegalFeeAmount = loan => Boolean(get(loan, "closingCosts.borrowerLegalFeeAmount"));

export const shouldShowInspectionFeeAmount = loan => Boolean(get(loan, "closingCosts.inspectionFeeAmount"));

export const shouldShowAppraisalFeeAmount = loan => Boolean(get(loan, "closingCosts.appraisalFeeAmount"));

export const shouldShowRateLockFeeAmount = loan => Boolean(get(loan, "closingCosts.rateLockFeeAmount"));

export const shouldShowHedgeFeeAmount = loan => Boolean(get(loan, "closingCosts.hedgeFeeAmount"));

export const shouldShowTitleAmount = loan => Boolean(get(loan, "closingCosts.titleAmount"));

export const shouldShowOtherAmount = loan => Boolean(get(loan, "closingCosts.otherAmount"));

export const shouldShowTotalAmount = loan => Boolean(get(loan, "closingCosts.totalAmount"));
